import * as React from "react";

function Export(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 14 14" fill="none" {...props}>
      <g clipPath="url(#prefix__clip0_1054_270238)">
        <path
          d="M3.5 0c-.965 0-1.75.785-1.75 1.75v2.625H3.5V1.75h6.199l.801.801v1.824h1.75V2.551c0-.465-.183-.91-.511-1.239l-.802-.8A1.75 1.75 0 009.7 0H3.5zm7 9.625v2.625h-7V9.625h7zm1.75.875h.875A.874.874 0 0014 9.625V7c0-.965-.785-1.75-1.75-1.75H1.75C.785 5.25 0 6.035 0 7v2.625c0 .484.391.875.875.875h.875v1.75c0 .965.785 1.75 1.75 1.75h7c.965 0 1.75-.785 1.75-1.75V10.5zm-.438-2.406a.655.655 0 01-.656-.656c0-.364.293-.657.656-.657.364 0 .657.293.657.657a.655.655 0 01-.656.656z"
          fill="var(--color-blue-500)"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0_1054_270238">
          <path fill="#fff" d="M0 0h14v14H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Export;
